import { SideSheet } from "components/materials";
import SidebarHeading from "./SidebarHeading";
import SidebarSection from "./SidebarSection";

// TODO: remove dot notation
SideSheet.Heading = SidebarHeading;
SideSheet.Section = SidebarSection;

export default SideSheet;
